export default __webpack_public_path__ + "static/media/license-activation-welcome.32d13d7e.png";